module.exports = __webpack_public_path__ + "static/media/iconrightgreen.0d15e2b3.svg";